import ClickAwayListener from '@mui/material/ClickAwayListener';
import Fade from '@mui/material/Fade';
import IconButton from '@mui/material/IconButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Popper from '@mui/material/Popper';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import CuratorIcon from '@mui/icons-material/MoreVert';
import React, { useEffect, useState } from 'react';
import { getRoles, getUser } from '../../helpers/token';
import Link from '@mui/material/Link';
import PostBlacklist from '../CuratorMenu/Actions/PostBlacklist';
import PopupPaper from '../Header/PopupPaper';
import FollowButton from '../Profile/FollowButton';
import BookmarkIcon from './BookmarkIcon';
import ReplyIcon from '@mui/icons-material/Reply';
import ReportDialog from './ReportDialog';
import SocialShareDialog from './SocialShareDialog';

const DotMenu = props => {
  const {
    onBmChange,
    author,
    permlink,
    tags,
    title,
    thumbnail,
    onEditClick,
    alwaysShowSaveBtn,
    editLink,
    replyAction,
    onCommentDelete,
  } = props;

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [listenClickAway, setListenClickAway] = React.useState(true);
  const [roles, setRoles] = useState(undefined);

  useEffect(() => {
    setRoles(getRoles());
  }, []);

  const isCurator = roles && roles.indexOf('team') !== -1;

  const handleClick = event => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'transitions-popper' : undefined;

  const handleClose = event => {
    if (anchorEl && anchorEl.contains(event.target)) {
      return;
    }

    setAnchorEl(null);
  };

  const handleEditClick = event => {
    handleClose(event);
    onEditClick();
  };

  const handleReplyClick = event => {
    handleClose(event);
    replyAction();
  };

  const menuItems = [];

  if (replyAction)
    menuItems.push(
      <>
        <MenuItem onClick={handleReplyClick}>
          <ListItemIcon>
            <ReplyIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Reply" />
        </MenuItem>
      </>,
    );

  if (onEditClick)
    menuItems.push(
      <>
        <MenuItem onClick={handleEditClick}>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Edit" />
        </MenuItem>
      </>,
    );

  if (onCommentDelete)
    menuItems.push(
      <>
        <MenuItem onClick={onCommentDelete}>
          <ListItemIcon>
            <DeleteIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Delete" />
        </MenuItem>
      </>,
    );

  if (editLink) {
    menuItems.push(
      <Link href={editLink}>
        <MenuItem>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="Edit"
            primaryTypographyProps={{ color: 'textPrimary' }}
          />
        </MenuItem>
      </Link>,
    );
  }

  if (!props.isCommentMode)
    menuItems.push(
      <div
        className={`d-block ${
          alwaysShowSaveBtn ? '' : 'd-xl-none d-lg-none d-md-none d-sm-none'
        }`}
      >
        <BookmarkIcon
          onBmChange={onBmChange}
          isMenuItem
          author={author}
          permlink={permlink}
        />
      </div>,
    );

  menuItems.push(
    <SocialShareDialog
      isCommentMode={props.isCommentMode}
      setListenClickAway={setListenClickAway}
      author={author}
      permlink={permlink}
      tags={tags}
      title={title}
      thumbnail={thumbnail}
    />,
  );

  if (getUser() !== author)
    menuItems.push(<FollowButton author={author} btnstyle="menuItem" />);

  if (isCurator) {
    menuItems.push(
      <PostBlacklist
        isComment={props.isCommentMode}
        setListenClickAway={setListenClickAway}
        author={author}
        permlink={permlink}
        isCommentMode={props.isCommentMode}
      />,
    );
  } else {
    menuItems.push(
      <>
        <ReportDialog
          isComment={props.isCommentMode}
          setListenClickAway={setListenClickAway}
          author={author}
          permlink={permlink}
        />
      </>,
    );
  }

  return (
    <>
      <IconButton
        size="small"
        className="m-1"
        onClick={handleClick}
        aria-label="Open menu"
      >
        <CuratorIcon className="textPrimary" />
      </IconButton>
      <Popper
        style={{ zIndex: 999 }}
        placement="bottom-end"
        id={id}
        open={open}
        anchorEl={anchorEl}
        transition
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <div>
              <PopupPaper>
                <ClickAwayListener
                  onClickAway={handleClose}
                  mouseEvent={listenClickAway ? 'onClick' : false}
                >
                  <MenuList>
                    {menuItems.map(item => {
                      return item;
                    })}
                  </MenuList>
                </ClickAwayListener>
              </PopupPaper>
            </div>
          </Fade>
        )}
      </Popper>
    </>
  );
};

export default DotMenu;
